import { store } from '@src/store';

export const elasticApmTags = {
  EAPM_TRANSACTION_SUCCESS: (data) => {
    const state = store.getState();
    const { firstName, lastName, userUUID, optumId } = state.user;
    return {
      event: 'eapm-api-transaction',
      data: {
        result: 'success',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid: userUUID,
        optumId,
        duration: data.duration,
        username: `${firstName} ${lastName}`,
        status: data.status,
        endpoint: data.endpoint,
      },
    };
  },
  EAPM_TRANSACTION_ERROR: (data) => {
    const state = store.getState();
    const { firstName, lastName, userUUID, optumId } = state.user;
    return {
      event: 'eapm-api-transaction',
      data: {
        result: 'error',
        appVersion: process.env.PACKAGE_VERSION,
        url: window.location.href,
        uuid: userUUID,
        optumId,
        duration: data.duration,
        username: `${firstName} ${lastName}`,
        status: data.status,
        endpoint: data.endpoint,
        code: data.code,
        message: data.message,
      },
    };
  },
};
